import { Checkbox } from '@/components/ui/checkbox/checkbox.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { currencyFormatter } from '@/utils/formatters/currency';

interface ExamCoverageRowProps {
  id: string;
  name: string;
  price: number;
}

export const ExamCoverageRow = ({ id, name, price }: ExamCoverageRowProps) => {
  return (
    <div className="px-6 py-5 border-b border-gray-300">
      <Checkbox id={`exam-coverage-row-${id}`} checked>
        <div className="flex flex-col">
          <Typography as="p" variant={TypographyVariant.BODY_TEXT} className="font-semibold text-gray-700">
            {name}
          </Typography>
          <Typography as="p" variant={TypographyVariant.BODY_TEXT} className="font-bold text-green-500">
            {currencyFormatter(price)}
          </Typography>
        </div>
      </Checkbox>
    </div>
  );
};
